<template>
    <div class="flex h-screen">
        <div class="h-full bg-zinc-100 p-3 w-80">
            <div v-for="textCompletion in textCompletions" class="my-1 cursor-pointer hover:font-medium"
                 :class="textCompletion === currentTextCompletion ? 'font-medium text-purple-600' : ''"
                 @click="onPromptClick(textCompletion)">{{textCompletion.prompt}}</div>
        </div>

        <div class="w-full m-5">

            <select class="w-1/2 border-gray-200 rounded-lg text-sm text-slate-700 py-2" v-model="textCompletionRequest.model">
                <option>gpt-3.5-turbo</option>
                <option>gpt-4</option>
            </select>

            <div class="my-4">System Prompt</div>

            <textarea v-model="textCompletionRequest.system_prompt" class="block w-1/2 rounded-lg border-zinc-200 shadow-sm
                    focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50" rows="3"></textarea>

            <div class="my-4">Prompt</div>

            <textarea v-model="textCompletionRequest.prompt" class="block w-1/2 rounded-lg border-zinc-200 shadow-sm
                    focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50" rows="3"></textarea>

            <button type="button"
                    class="my-3 bg-violet-600 hover:bg-violet-800 text-white px-8 py-2 rounded-md"
                    @click="onAskClick">Ask AI Assistant
            </button>

            <div v-if="currentTextCompletion" class="px-5">

<!--                <button type="button"-->
<!--                        class="bg-violet-600 hover:bg-violet-800 text-white my-1 px-4 py-1 rounded"-->
<!--                        @click="onSelectAll">Select All-->
<!--                </button>-->

                <div v-for="contentResponse in parsedResponses" class="my-1 cursor-pointer"
                     :class="contentResponse === acceptedText ? 'font-bold' : 'hover:font-medium'">
                    {{ contentResponse }}
                </div>

            </div>

<!--            <textarea v-model="currentPrompt" class="block w-3/4 rounded-lg border-zinc-200 shadow-sm-->
<!--                    focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50" rows="10"></textarea>-->
        </div>
    </div>
</template>

<script>
import TextCompletionService from "../../app/services/TextCompletionService";

export default {
    name: 'AiHome',
    props: ['prop1', 'prop2'],
    data () {
        return {
            model: webase.model,
            service: new TextCompletionService(),
            textCompletions: [],
            currentTextCompletion: null,
            // currentPrompt: '',
            acceptedText: null,
            textCompletionRequest: {
                model: 'gpt-3.5-turbo',
                prompt: '',
                system_prompt: ''
            }
        }
    },
    computed: {
        aiResponse() {
            let contentString = this.currentTextCompletion.response['choices'][0]['message']['content']
            return contentString
        },
        parsedResponses() {
            let contentString = this.aiResponse
            let startString = "\n\n"

            if(contentString.indexOf(startString) === 0) {
                contentString = contentString.substring(startString.length)
            }

            return contentString.split("\n")
        }
    },
    mounted () {
        this.loadTextCompletions()
    },
    methods: {
        loadTextCompletions() {
            this.service.list().then((response) => {
                this.textCompletions = response
            }).catch((message) => {
                console.log('error loading AI prompts')
                console.log(message)
            })
        },
        onPromptClick(textCompletion) {
            this.currentTextCompletion = textCompletion
        },
        onAskClick() {
            this.model.loading = true
            let request = {
                text_completion: this.textCompletionRequest
            }

            this.service.create(request).then((textCompletion) => {
                this.textCompletions.push(textCompletion)
                this.currentTextCompletion = textCompletion
                this.model.loading = false
            }).catch((message) => {
                console.log('error saving AI prompt')
                console.log(message)
                this.model.loading = false
            })

        },
    }
}
</script>
